import React, { Component } from 'react';
import '../css/Login.scss';
import Auth from "../modules/auth/Auth";



class Welcome extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    getVolunteerNumber = () => {
        (async () => {
            let [res, err] = await Auth.superAuthFetch(`/api/CustomUsers/GetVolunteersNumber`, null, true);
            if (err || res.err) { console.log("woo too bad", err); return }
            if (res) {
                this.setState({ volunteersNumber: res });
            }
        })()
    }

    componentDidMount = () => {
        this.getVolunteerNumber();
    }

    render() {
        return (
            <div className="blue-bg App loginPage">
                <div className="yellowSticker2">מאגר המתנדבים של המדינה!</div>
                {this.state.volunteersNumber ? <div className="volunteerNumber">{this.state.volunteersNumber}</div> : <div id="minusMargin" className="flexContainer"><img src="/images/otherIcons/spinner.svg" /></div>}
                <div className="headline">מתנדבים ומתנדבות מכל המדינה <br /> כאן בשביל לתת כתף בזמן מגיפת הקורונה</div>
                <div className="flexContainer">
                    <button id="loginButton" onClick={() => { this.props.history.push("/login") }}>כניסה למאגר</button>
                </div>
                <div onClick={() => this.props.history.push("/")} id="first-go-to-login">הרשמת מתנדב</div>
            </div>
        );
    }
}

export default Welcome;